import React from "react";
import { ChantSelect } from "../../../../../../CommonComponents";
import CustomFields from "../CustomFields";

const BIRTHDAY_OPTIONS = [
  { value: "month and day", label: "Month and day" },
  { value: "month, day and year", label: "Month, day and year" },
];

const ToggleItem = ({
  label,
  fieldId,
  checked,
  onChange,
  disabled,
  hint,
  children,
}) => (
  <div className="reg-toggle-item">
    <div className="reg-toggle-left">
      <input
        style={{ height: 18, width: 18, cursor: disabled ? "default" : "pointer" }}
        type="checkbox"
        id={fieldId}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <label className="reg-toggle-label" htmlFor={fieldId}>
        {label}
      </label>
      {children}
    </div>
    {hint && <span className="reg-toggle-hint">{hint}</span>}
  </div>
);

const FormFieldsStep = ({
  formFields,
  customFieldDetails,
  backgroundColor,
  handleCheckChange,
  handleFormFieldSelectChange,
  handleCustomFieldChange,
  handleNext,
  setShowChapterModal,
}) => {
  return (
    <>
      {/* Standard Fields */}
      <div className="reg-section" style={{ marginTop: 24 }}>
        <h4 className="reg-section-title">Registration Form Fields</h4>
        <p style={{ fontSize: 14, color: "#666", marginBottom: 16 }}>
          Select which fields to include in the registration form. Required
          fields cannot be disabled.
        </p>

        <div className="reg-toggle-list">
          <ToggleItem
            label="Full Name"
            fieldId="fullName"
            checked={formFields.fullName}
            disabled={true}
            onChange={handleCheckChange}
            hint="Required"
          />

          <ToggleItem
            label="Email"
            fieldId="email"
            checked={formFields.email}
            disabled={true}
            onChange={handleCheckChange}
            hint="Required"
          />

          <ToggleItem
            label="Phone"
            fieldId="phone"
            checked={formFields.phone}
            onChange={handleCheckChange}
            hint="Required if selected"
          />

          <ToggleItem
            label="Address"
            fieldId="address"
            checked={formFields.address}
            onChange={handleCheckChange}
            hint="Required if selected"
          />

          {/* Birthday - special: has a select instead of checkbox */}
          <div className="reg-toggle-item">
            <div className="reg-toggle-left">
              <label className="reg-toggle-label" style={{ minWidth: 80 }}>
                Birthday
              </label>
              <div style={{ width: 200 }}>
                <ChantSelect
                  value={formFields.birthday || undefined}
                  onChange={(value) =>
                    handleFormFieldSelectChange("birthday", value || "")
                  }
                  placeholder="--Select--"
                  options={BIRTHDAY_OPTIONS}
                  allowClear
                />
              </div>
            </div>
            <span className="reg-toggle-hint">Required if selected</span>
          </div>

          <ToggleItem
            label="Join mailing list?"
            fieldId="joinMailingList"
            checked={formFields.joinMailingList}
            onChange={handleCheckChange}
            hint="Checkbox"
          />

          <ToggleItem
            label="Get notified of volunteer opportunities?"
            fieldId="shareVolunteerOpportunities"
            checked={formFields.shareVolunteerOpportunities}
            onChange={handleCheckChange}
            hint="Checkbox"
          />

          <ToggleItem
            label="Official Club Member?"
            fieldId="officialClubMember"
            checked={formFields.officialClubMember}
            onChange={handleCheckChange}
            hint="Asks for membership number"
          />

          <ToggleItem
            label="Season Ticket Holder?"
            fieldId="seasonTicketHolder"
            checked={formFields.seasonTicketHolder}
            onChange={handleCheckChange}
            hint="Asks for section and # tickets"
          />

          <ToggleItem
            label="Member Referral"
            fieldId="memberReferral"
            checked={formFields.memberReferral}
            onChange={handleCheckChange}
            hint="Tracks referrals via email"
          />

          {/* Chapters - special: has a config action */}
          <div className="reg-toggle-item">
            <div className="reg-toggle-left">
              <input
                style={{ height: 18, width: 18, cursor: "pointer" }}
                type="checkbox"
                id="chapters"
                checked={formFields.chapters}
                onChange={handleCheckChange}
              />
              <label className="reg-toggle-label" htmlFor="chapters">
                Chapter
              </label>
              <div className="reg-toggle-action">
                <span
                  className="span-link"
                  onClick={() => setShowChapterModal(true)}
                >
                  Configure
                </span>
              </div>
            </div>
            <span className="reg-toggle-hint">Required if selected</span>
          </div>
        </div>
      </div>

      {/* Custom Fields */}
      <div className="reg-section">
        <CustomFields
          customFieldDetails={customFieldDetails}
          onCustomFieldChange={handleCustomFieldChange}
        />
      </div>

      {/* Navigation */}
      <div className="reg-step-nav">
        <button
          className="reg-btn reg-btn-back"
          type="button"
          onClick={(e) => {
            e.preventDefault();
            handleNext("formFieldStep", "basicsStep");
          }}
        >
          Back
        </button>
        <button
          className="reg-btn reg-btn-next"
          type="button"
          style={{ backgroundColor: backgroundColor || "#1890ff" }}
          onClick={(e) => {
            e.preventDefault();
            handleNext("formFieldStep", "donationStep");
          }}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default FormFieldsStep;
